import React from "react";
import "./HeaderPromo.css";

export default function HeaderPromo({
  image,
  alt = "Promotion",
  href = null,
  ariaLabel = "Voir la promotion",
  height = "auto", // tu peux mettre "tall" si tu veux une bannière plus haute
}) {
  const Wrapper = href ? "a" : "div";

  return (
    <section className={`hp-wrap ${height === "tall" ? "hp-tall" : ""}`}>
      <Wrapper
        className="hp-card"
        {...(href
          ? { href, "aria-label": ariaLabel }
          : { role: "img", "aria-label": alt })}
      >
        <img className="hp-img" src={"/promo.jpg"} alt={alt} loading="eager" />
      </Wrapper>
    </section>
  );
}